if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.groupColorSwatches();

        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      groupColorSwatches() {
        const isReplacementLens = document.querySelector('.product__block--meta')?.textContent.includes('Replacement Lens');
        if (!isReplacementLens) return;

        const fieldsets = Array.from(
          this.querySelectorAll(
            '.product-form__input--swatch:not(.grouped), .product-form__input--color:not(.grouped)'
          )
        );
        fieldsets.forEach((fieldset) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
          if (!inputs.length) return;

          const groups = { Transitions: [], Mirrored: [], Tinted: [] };

          inputs.forEach((input) => {
            const label = fieldset.querySelector('label[for="' + input.id + '"]');
            if (!label) return;
            const text = input.value.toLowerCase();
            const item = { input, label };
            if (text.includes('photochromic')) groups.Transitions.push(item);
            else if (text.includes('mirrored')) groups.Mirrored.push(item);
            else groups.Tinted.push(item);
          });

          const container = document.createElement('div');
          container.className = 'lens-color-group__container';

          Object.entries(groups).forEach(([title, arr]) => {
            if (!arr.length) return;
            const wrap = document.createElement('div');
            const heading = document.createElement('div');
            heading.className = 'lens-color-group__title';
            heading.textContent = title;
            const row = document.createElement('div');
            row.className = 'lens-color-group__swatches';
            arr.forEach((it) => {
              row.appendChild(it.input);
              row.appendChild(it.label);
            });
            wrap.appendChild(heading);
            wrap.appendChild(row);
            container.appendChild(wrap);
          });

          const legend = fieldset.querySelector('legend');
          if (legend) legend.after(container);
          else fieldset.prepend(container);

          fieldset.classList.add('grouped');
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}